import { Pipe, PipeTransform } from "@angular/core";
import { isBpayTotalBillPayment } from "src/class/bpay";

/** True when this narration is the daily BPAY settlement credit */
@Pipe({
    name: "isBpayTotal",
})
export class IsBpayTotalPipe implements PipeTransform {

    transform(narration?: unknown): boolean {
        return isBpayTotalBillPayment(narration)
    }

}

/** Narrows transactions to the daily BPAY settlement credits */
@Pipe({
    name: "filterBpayTotal",
})
export class FilterBpayTotalPipe implements PipeTransform {

    transform(input?: any[]): any[] {
        return (input ?? []).filter(val => isBpayTotalBillPayment(val?.narration))
    }

}
